
import { round10 } from '~/fc/helpers'

export default {
    name: 'UnitTypesTemplate',
    components: {
        AdInPage: () => import(/* webpackChunkName: "AdInPage" */ '../partials/ads/AdInPage'),
        TryFree: () => import(/* webpackChunkName: "TryFree" */ '../partials/page/TryFree'),
        SecurityAndCompliance: () => import(/* webpackChunkName: "SecurityAndCompliance" */ "~/components/ui/SecurityAndCompliance")
    },
    data: () => ({
        unitInfo: {}
    }),
    computed: {
        info() {
            return this.$store.state.info
        }
    },
    created() {
        this.unitInfo = JSON.parse(JSON.stringify(this.info))
    },
    mounted() {
        const el = document.getElementById(this.unitInfo.unit_types[0].common_name_norm)
        el.value = 1
        this.process(el)
    },
    methods: {
        process(el, $event) {
            let id = ''
            let value = ''
            if (el && el.id) {
                id = el.id
                value = el.value
            } else if (event && event.target && event.target.value) {
                id = event.target.id
                value = event.target.value
            } else {
                return
            }
            const conversionData = [...this.unitInfo.unit_conversion]
            const result = conversionData.filter(
                data => data.source.common_name.replace(/ /g, '-') === id
            )
            result.forEach((v) => {
                v.target.common_name = v.target.common_name.replace(/ /g, '-')
                if (document.getElementById(v.target.common_name)) {
                    let formula = v.formula
                    formula = formula.replace('value', value)
                    // eslint-disable-next-line no-eval
                    let result = eval(formula)

                    if (round10(result, -7) !== 0) {
                        result = round10(result, -7)
                    } else {
                        result = round10(result, -13)
                    }
                    document.getElementById(v.target.common_name).value = result
                }
            })
        }
    }
}
